import DotsPattern from "../../../components/ui/icons/DotsPattern";
import BannerAvatar from "../../../components/ui/BannerAvatar";
import { useProfile } from "../../auth/hooks/useProfile";
import { useNavigate } from "react-router-dom";

const CongratsBanner: React.FC = () => {
  const { user } = useProfile();
  const navigate = useNavigate();
  return (
    <div
      className="relative rounded-xl overflow-hidden mb-6 flex flex-col sm:flex-row items-center sm:items-center min-h-[314px]"
      style={{
        background:
          "linear-gradient(-23deg, rgba(0, 103, 255, .175) 0%, #ffffff 100%)",
        padding: "32px 24px",
        gap: 24,
        boxShadow: "0 2px 14px #0000001a",
      }}
    >
      <DotsPattern />

      <div className="relative z-[1] flex-shrink-0">
        <BannerAvatar src={user?.image ?? undefined} />
      </div>

      <div className="relative z-[1] flex flex-col items-center text-center sm:items-start sm:text-left">
        <h1
          className="text-blue font-medium mb-2"
          style={{ fontSize: "clamp(20px, 3vw, 26px)", lineHeight: 1.2 }}
        >
          Congratulations, {user?.first_name}!
        </h1>

        <div
          style={{
            width: 40,
            height: 3,
            background: "#3b519c",
            borderRadius: 2,
            marginBottom: 14,
          }}
        />

        <p className="text-blue font-medium font-primary mb-6 leading-normal max-w-[400px]">
          Your survey is complete and you have unlocked your Individual Report.
        </p>

        <button
          className="btn btn-primary btn-md w-full sm:w-auto"
          onClick={() => navigate("/individual-results")}
        >
          View Results
        </button>
      </div>
    </div>
  );
};

export default CongratsBanner;
